import React, { forwardRef } from "react";
import { X } from "lucide-react";
import { migrationRolesData } from "../data/migrationRolesData";

const OptionsList = forwardRef(({
  toggleOptionsList,
  handleOptionHover,
  handleOptionLeave,
  handleSelectOption
}, ref) => {
  return (
    <div 
      ref={ref}
      className="absolute bottom-20 left-16 bg-white rounded-lg shadow-xl border border-gray-200 w-72 max-h-96 overflow-y-auto z-20"
    >
      <div className="flex justify-between items-center p-3 border-b border-gray-200 bg-gray-50">
        <h3 className="font-medium">Migration Roles</h3>
        <button 
          onClick={toggleOptionsList}
          className="p-1 rounded-full hover:bg-gray-200"
        >
          <X size={18} />
        </button>
      </div>
      
      <div className="divide-y divide-gray-100">
        {migrationRolesData.map((option, index) => (
          <button
            key={index}
            onClick={() => handleSelectOption(option.title)}
            onMouseEnter={(e) => handleOptionHover(option.description, e)}
            onMouseLeave={handleOptionLeave}
            className="w-full p-3 text-left hover:bg-gray-100 flex justify-between items-center"
          >
            <span>{option.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
});

export default OptionsList;